import React, { useEffect,useState } from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';

import FormInput from '../../Common/formInput';
import { Grid, Button, Box, InputLabel, Snackbar } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getUserDetailsData, updatePaymentDetails } from '../../../actions/get-user-details';
import { currentUserSelector } from '../../../selectors/currentUserSelector'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import Alert from '@material-ui/lab/Alert';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Card, CardContent } from '@material-ui/core';
import CheckoutForm from './checkoutForm';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles({
    inputLabel: {
        color: '#08090a',
        fontSize: '0.875rem',
        fontWeight: '400',
        paddingBottom: '0.625rem',
        //display: 'inline-flex !important',
    },
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '8px 14px'
        },
    }
})


const PaymentMethodForm = () => {
    const { t } = useTranslation();
    const userCardData = useSelector(state => state.fetchUserDetails.data);

    const dispatch = useDispatch();
    const classes = useStyles();
    const [publicKey, setKey] = useState('pk_live_Xhm5mtPuQOJFarOf0pogv66i00vH5kLUzu');
    // const [publicKey, setKey] = useState('pk_test_MU3xLLM0majqVEQzDkzYeA5h009dI3g9hM');
    const [stripePromise, setStripePromise] = useState(null);
    const currentUser = useSelector(currentUserSelector);
    const [openEditDetail, setOpenEditDetail] = React.useState(false);
    const [cardNumber, setCardNumber] = React.useState('');
    const [cvv, setCVV] = React.useState();
    const [errorMessage, setErrorMessage] = React.useState('');
    const [expiryDate, setExpiryDate] = React.useState();
    const [snackBarMessage, setSnackBarMessage] = React.useState('');
    const [paymentMethodId,setPaymentMethodId] = useState(null);
    const handlePaymentMethodId = (paymentMethodId) => {
        setPaymentMethodId(paymentMethodId);
    }

    useEffect(() => {
        dispatch(getUserDetailsData({ user_id: currentUser.user.id }))
    }, [])

    useEffect(() => {
        initizeCardData()
    }, [userCardData])

    useEffect(() => {
        console.log("key set",publicKey);
         if (publicKey) {
            setStripePromise(loadStripe(publicKey));
          }
    }, [publicKey]);

    const initizeCardData = () => {

        if (userCardData) {
            console.log("card details fetched from api",userCardData.expiry_date)
            const newDate = moment();
            newDate.set('year', userCardData.expiry_year);
            newDate.set('month', userCardData.expiry_date-1);
            const userExpiryDate = newDate.format('MMM, YYYY');
            setCardNumber(userCardData?.card_number || '');
            setExpiryDate(userExpiryDate);
            setCVV(userCardData.cvv || '');
        }
    }

    const handleCardNumber = (cardNumber) => {
        setCardNumber(cardNumber);

        // if (validator.isCreditCard(cardNumber)) {
        //     setErrorMessage("valid");
        //     setCardNumber(cardNumber);
        // } else {
        //     setErrorMessage("Card Number is not valid");
        // }
    }

    const handleCancel = () => {
        initizeCardData();
        setOpenEditDetail(false);
    }

    const handleEditDetails = () => {
        // setSnackBarMessage('Updating payment card details will be enabled soon. Stay Tuned');
        setCardNumber('');
        setExpiryDate(null);
        setCVV('');
        setOpenEditDetail(true);
    }

    const handleSubmit = () => {
        const { id } = currentUser;
        dispatch(updatePaymentDetails({
            user_id: currentUser.user.id,
            // card_number: cardNumber,
            // expiry_month: moment(expiryDate).month(),
            // expiry_year: moment(expiryDate).year(),
            // cvv: cvv,
            payment_method_id: paymentMethodId,
        }));
        setOpenEditDetail(false);
    }

    const formatCardNumber = (card) => {
        const visibleDigits = 4;
        const hiddenDigits = card.length > visibleDigits ? (card.length - visibleDigits) : card.length;
        return ('*'.repeat(hiddenDigits) + card.slice(hiddenDigits));
    }

    const handlCloseSnackBar = () => {
        setTimeout(() => setSnackBarMessage(''), 6000);
    }

    const handlClose = () => {
        setSnackBarMessage('');
    }

    return (
        <Grid container>
            {/* <Grid item xs={12}>
                <FormInput
                    id='cardNumber'
                    label='Card Number*'
                    placeholder=""
                    name="cardNumber"
                    disabled={!openEditDetail}
                    value={formatCardNumber(cardNumber)}
                    onChange={(e) => handleCardNumber(e.target.value)}
                    inputProps={{
                        maxLength: 16,
                        minLength: 16,
                        inputMode: 'numeric'
                    }}
                />
            </Grid> */}
            {openEditDetail ? (
                <>
                    <Grid item xs={12} md={6}>
                        {/* <Box padding='8px 20px 20px 10px'>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <InputLabel className={classes.inputLabel}>Expiry Date</InputLabel>
                                <DatePicker
                                    className={classes.root}
                                    openTo="year"
                                    fullWidth
                                    views={['month', 'year']}
                                    // label='Year'
                                    inputVariant="outlined"
                                    value={expiryDate}
                                    disablePast
                                    onChange={setExpiryDate}
                                    format={'MMM, YYYY'}
                                />
                            </MuiPickersUtilsProvider>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormInput
                            placeholder="eg:123"
                            disabled={!openEditDetail}
                            name="cvv"
                            value={cvv}
                            onChange={(e) => setCVV(e.target.value)}
                            label='CVV'
                            type={'password'}
                            inputProps={{
                                maxLength: 3,
                                minLength: 3,
                                inputMode: 'numeric'
                            }}
                        /> */}
                        {stripePromise ? (
        <Elements stripe={loadStripe(publicKey)}>
          <CheckoutForm onPaymentMethodId={handlePaymentMethodId} />
        </Elements>
      ) : (
        <CircularProgress size={60} />
      )}
                    </Grid></>) :
                (<><Grid item xs={12}>
                    <FormInput
                        id='cardNumber'
                        label='Card Number*'
                        placeholder=""
                        name="cardNumber"
                        disabled={!openEditDetail}
                        value={formatCardNumber(cardNumber)}
                        onChange={(e) => handleCardNumber(e.target.value)}
                        inputProps={{
                            maxLength: 16,
                            minLength: 16,
                            inputMode: 'numeric'
                        }}
                    />
                </Grid><Grid item xs={12} md={6}>
                    <FormInput
                        placeholder="eg:05/2025"
                        name="exp_month"
                        value={expiryDate}
                        disabled
                        label='Expiry Date'
                    />
                </Grid></>)
            }
            <Grid item xs={12}>
                <Box pt={2} display="flex" flexDirection="row-reverse" justifyContent="">
                    {
                        openEditDetail ? (
                            <>
                                <Button disableRipple variant="contained" color="primary" style={{ marginLeft: '0.5rem' }} onClick={handleSubmit} autoFocus>
                                    Confirm
                                </Button>
                                <Button ml={1} disableRipple variant="contained" onClick={handleCancel} >
                                    Cancel
                                </Button>
                            </>
                        ) : (<Button disableRipple variant="contained" color="primary" style={{ marginLeft: '0.5rem' }} onClick={handleEditDetails} autoFocus>
                            Edit Detail
                        </Button>)
                    }
                </Box>
            </Grid>
            {!!snackBarMessage && (
                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        autoHideDuration={1000}
                        open={!!snackBarMessage}
                        onClose={handlCloseSnackBar}>
                        <Alert
                            elevation={6}
                            variant="filled"
                            onClose={handlClose}
                            severity="info">
                            {snackBarMessage}
                        </Alert>
                    </Snackbar>
                )}
        </Grid >
    );
};

export default PaymentMethodForm;
